module.exports = __webpack_public_path__ + "static/icon_crucible-d429e946d407c0f7cdc0bb37e3f62a1f.svg";